import { useUpdateCompanyStockConfigurationFixedCost } from '@/core/domain/stock/Configuration/Configuration.hooks';
import { useRouteMatchParam } from '@/hooks';
import { Button, Modal, ModalProps, Typography } from 'antd';

const { Text } = Typography;

interface Props extends ModalProps {
  onCancel: () => void;
  fixedCost: number;
}

const FixedCostModal = ({ fixedCost, ...props }: Props) => {
  const companyId = +useRouteMatchParam('companyId');

  const { mutateAsync: FixedCostMutateAsync, isLoading: FixedCostIsLoading } =
    useUpdateCompanyStockConfigurationFixedCost();

  const handleOk = async (recalculatePrices: boolean) => {
    await FixedCostMutateAsync({
      companyId,
      fixedCost,
      recalculatePrices,
    });

    props.onCancel();
  };

  return (
    <Modal
      {...props}
      title="Atenção!"
      onCancel={props.onCancel}
      footer={[
        <Button onClick={props.onCancel}>Fechar</Button>,
        <Button
          type="primary"
          onClick={() => handleOk(false)}
          loading={FixedCostIsLoading}
        >
          Salvar
        </Button>,
        <Button
          type="primary"
          onClick={() => handleOk(true)}
          loading={FixedCostIsLoading}
        >
          Salvar e Atualizar
        </Button>,
      ]}
    >
      <Text>
        Ao atualizar a composição de preços, é possível que o preço de todo o
        seu estoque de peças e insumos seja ajustado de acordo com essa nova
        composição.
      </Text>
    </Modal>
  );
};

export default FixedCostModal;
